import { Component, OnInit, Input } from '@angular/core';
import { ColetaService } from '../coleta.service';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { ResultadoColeta } from '../../comum/modelos/resultado-coleta';
import { DetalheColeta } from '../../comum/modelos/detalhe-coleta';
import { ResultadoCriterioColeta } from '../../comum/modelos/resultado-criterio-coleta';

@Component({
    selector: 'app-lista-coletas',
    templateUrl: './lista-coletas.component.html',
    styleUrls: ['./lista-coletas.component.css']
})
export class ListaColetasComponent implements OnInit {

    @Input() resultadoColeta: ResultadoColeta;
    @Input() resultadoCriterioColeta: ResultadoCriterioColeta;

    filtroPesquisaNomeIndicador: string;
    detalhesColeta: DetalheColeta[];
    statusCode: number;
    public paginacao: Paginacao;
    public evento: Evento;

    public loading = false;

    constructor (
        private _coletaService: ColetaService,
        private _comumService: ComumService) {
        this.detalhesColeta = new Array<DetalheColeta>();
        this.paginacao = new Paginacao();
        this.evento = this._comumService.evento;
        this.loading = false;
        this.detalhesColeta = new Array<DetalheColeta>();
        if (this.evento !== undefined) {
            setTimeout(() => {
                this._comumService.cleanEvent();
            }, 2000);
        }
    }

    ngOnInit() {
        this.paginacao.itens = 5;
        this.paginacao.page = 1;
        this.loading = true;
        const result = this.resultadoColeta;
        result.pesquisaComFoto = false;
        this._coletaService.obterDetalhesColetasHttp(result).subscribe(detalhesColeta => {
            detalhesColeta.body.forEach(detalheColeta => {
                if (detalheColeta.criterioAvaliacao.nomeCriterioAvaliacao === this.resultadoCriterioColeta.nomeCriterioAvaliacao) {
                    this.detalhesColeta.push(detalheColeta);
                }
            });
            this.loading = false;
        });
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/coleta/lista-coletas/lista-coletas.component.ts